import type { RunMode } from '../core/types.js';

interface Props {
  value: RunMode;
  onChange(mode: RunMode): void;
  disabled?: boolean;
}

export function RunModeToggle({ value, onChange, disabled }: Props) {
  return (
    <div>
      <label>Run mode</label>
      <div className="toggle-group" role="group" aria-label="Run mode">
        <button
          type="button"
          className={value === 'manual' ? 'active' : ''}
          onClick={() => onChange('manual')}
          disabled={disabled}
        >
          Manual
        </button>
        <button
          type="button"
          className={value === 'scripted' ? 'active' : ''}
          onClick={() => onChange('scripted')}
          disabled={disabled}
        >
          Scripted
        </button>
        <button
          type="button"
          className={value === 'expert' ? 'active' : ''}
          onClick={() => onChange('expert')}
          disabled={disabled}
        >
          Expert
        </button>
      </div>
    </div>
  );
}
